export interface IPopularService {
  status: number;
  Message: string;
  Popular_Service_Data: IPopularServiceDatum[];
}

export interface IPopularServiceDatum {
  id: number;
  name: string;
  category_link: string;
  category_business_count: number;
  category_images: ICategoryImage[];
  category_group: string;
  tag_health_condition: string;
}

export interface IBusinessSearchList {
  name: string;
  slug: string;
  distance: number;
  city: string;
  online_booking: boolean;
  business_class_active: boolean;
}

export interface IHealthConditionList {
  id: number;
  name: string;
  is_online: boolean;
  suburb: IHealthConditionSuburb[];
}

export interface IHealthConditionSuburb {
  lat: number;
  lng: number;
  state: string;
  city: string;
  post_code: string;
}

export interface ICategoryImage {
  id: number;
  correct_image: string;
  correct_thumb_image: string;
  image: string;
  thumb_image: null | string;
  name: string;
  type_of_url: string;
  category: number;
}

export class Prediction {
  public reference = '';
  public description = '';
  public place_id = '';
  public latitude = '';
  public longitude = '';
  public postal_code = '';
  public structured_formatting = {
    main_text: ''
  };
}

export interface ILocationDropdownList {
  text: string;
  displayText: string;
  place_id: string;
  prediction: Prediction;
}

// =================================================================================================

export interface IAllCategories {
  status: number;
  Message: string;
  avaana_categories: IAvaanaCategory[];
}

export interface IAvaanaCategory {
  id: number;
  category_serviceArray: ICategoryServiceArray[];
  category_images: ICategoryImage[];
  category_business_count: number;
  name: string;
  seo_name: null | string;
  category_link: string;
  category_group: string;
  category_image: null | string;
  category_image_name: null | string;
  cities: string[];
  tag_health_condition: null | string;
  helping_tags: Array<null | string>;
  added_by: string;
  season_priority: number;
  category_business_type: string;
  physical: boolean;
  mental: boolean;
  natural: boolean;
  fitness: boolean;
  online: boolean;
}

export interface ICategoryServiceArray {
  id: number;
  name: string;
  added_by: string;
}

// Location Interface

export class Location {
  public city_name = 'Sydney';
  public post_code = '2000';
  public lng: string | number = '151.2092955';
  public lat: string | number = '-33.8688197';
  public state_name = 'New South Wales';
}

export interface IBusinessMain {
  name: string;
  id: number;
  slug: string;
  online_booking: boolean;
  business_class_active: boolean;
  mobile_booking: boolean;
  business_location: IBusinessLocation;
  business_detail: IBusinessDetail;
  business_images: IBusinessImage[];
  business_service: IBusinessService[];
  business_practitioner: IBusinessPractitioner[];
  business_service_typeArray: IBusinessServiceTypeArray[];
  business_rating: IBusinessRating;
  premium: boolean;
  badges: IBadge2[];
}

export interface IBusinessLocation {
  id: number;
  distance: string;
  uuid: string;
  address: string;
  street: string;
  city: string;
  state: string;
  postal_code: string;
  lat: number;
  lng: number;
  is_active: boolean;
  business: number;
}

export interface IBusinessDetail {
  id: number;
  logo_image: string;
  correct_image: string;
  thumb_image: string;
  business_profile: string;
  logo_name: string;
  cancelation_policy: number;
  max_lead_time: number;
  max_feature_time: number;
  reviews_active: string;
  website: string;
  facebook_link: string;
  instagram_link: string;
  certifications: string;
  insurance_accepted: string;
  business_incorporation: string;
  security_policy: string;
  provide_service: string;
  philosophy: string;
  mobile_service: boolean;
  suburb: string;
  post_code: string;
  business_radius: number;
  online_service: boolean;
  software: string;
  link: string;
  google_rating: number;
  google_total_reviews: number;
  business: number;
}

export interface IBusinessImage {
  id: number;
  correct_image: string;
}

export interface IBusinessService {
  id: number;
  images: IBusinessImage[];
  badges: IBadge[];
  service_practitioner_detail: IServicePractitionerDetail[];
  uuid: string;
  service_name: string;
  improvised_name: string;
  slug: string;
  online_booking: boolean;
  category_name: string;
  length_of_service: string;
  length_of_booking_slot?: string;
  service_practitioner: string[];
  price: number;
  cliniko_appointment_type: string;
  discount: number;
  description: string;
  discount_description: string;
  discount_offer: string;
  image1?: string;
  image2: string;
  service_type: string;
  mode_of_service: string[];
  customer_intake: number;
  business_type: string;
  priority: number;
  sync_status: boolean;
  last_sync: string;
  enable_exclude_search_service: boolean;
  app_service: boolean;
  external_calendar_status: boolean;
  hide_in_market_place: boolean;
  hide_in_avaana_live: boolean;
  created_at: string;
  updated_at: string;
  business: number;
}

export interface IBadge {
  text: string;
  color: string;
}

export interface IServicePractitionerDetail {
  id: number;
  name: string;
  slug: string;
  email: string;
}

export interface IBusinessPractitioner {
  id: number;
  logo_image: string;
  image_1: string;
  image_2: string;
  practiitioner_appointments: [];
  practitioner_new_appointments: [];
  practitioner_block_times: [];
  temporary_appointments: [];
  email: string;
  uuid: string;
  logo_name: string;
  name: string;
  slug: string;
  practitioner_gender: string;
  practitioner_certificates: string[];
  profession_title: string;
  spoken_languages: string[];
  profile: string;
  external_calendar_status: boolean;
  practitioner_status: string;
  practitioner_hours: [];
  ahpra: string;
  external_calendar_url: string;
  acuity_external_calendar_id: string;
  timezone: string;
  timezone_id: string;
  logic_health_partner: boolean;
  specialization: string[];
  qualification: string[];
  badges: string;
  hide: boolean;
  sync_status: boolean;
  last_sync: string;
  business: number;
  link_calendar: number;
}

export interface IBusinessServiceTypeArray {
  id: number;
  category_serviceArray: ICategoryServiceArray[];
  category_images: ICategoryImage[];
  name: string;
  seo_name: string;
  category_link: string;
  category_group: string;
  category_image: string;
  category_image_name: string;
  cities: string[];
  tag_health_condition: string;
  helping_tags: string | undefined[];
  added_by: string;
  season_priority: number;
  category_business_type: string;
  physical: boolean;
  mental: boolean;
  natural: boolean;
  fitness: boolean;
  online: boolean;
}

export interface IBusinessRating {
  rate: number;
  count: number;
  score: number;
}

export interface IBadge2 {
  text: string;
  color: string;
}

export interface IBlogPost {
  id: number;
  post_date: string;
  post_title: string;
  image: string;
  description: string;
  url: string;
  categories: number[];
  author: number;
}

export interface IIconsList {
  path: string;
  name: string;
}

/* *******************
business provider
********************** */

export class BusinessProviderLocation {
  public id!: number;
  public address!: string;
  public city!: string;
  public state!: string;
  public postal_code!: string;
  public lat!: string;
  public lng!: string;
  public business!: string;
  public street!: string;
}

export class BusinessProviderInfo {
  public id!: number;
  public business_telephone!: string;
  public contact_name!: string;
  public email!: string;
  public facebook_link!: string;
  public location_data!: BusinessProviderLocation;
  public name!: string;
  public tel_no!: string;
  public website!: string;
}

export class BusinessProviderSchedule {
  public id!: number;
  public cancelation_policy!: number;
  public max_lead_time!: number;
  public Business_timing!: BusinessProviderTiming[];
  public booking_mode!: string;
  public business!: string;
}

export class BusinessProviderServices {
  public id!: number;
  public service_name!: string;
  public category_name!: string;
  public business_practitioner!: string[];
  public length_of_service!: string;
  public price!: number;
  public discount!: number;
  public discount_offer!: string;
  public discount_description!: string;
  public description!: string;
  public service_type!: string;
  public length_of_booking_slot!: number;
  public image1!: string;
  public image2!: string;
  public imagePath!: string;
  public business_type!: string;
  public customer_intake!: number;
  public capacity_total!: number;
  public service_image!: any[];
  public images!: any[];
  public online_booking!: boolean;
  public mobile_booking!: boolean;
  public spotsLeft: any;
  public additional_info = '';
  public cancellation_policy = '';

  public business!: string;
  public service_practitioner!: string[];
  public mode_of_service?: any[];
  public image_name!: string;
}

export class BusinessProviderClasses {
  public id!: number;
  public service_name!: string;
  public category_name!: string;
  public business_practitioner!: string[];
  public length_of_service!: string;
  public price!: number;
  public class_type!: number;
  public discount!: number;
  public discount_offer!: string;
  public discount_description!: string;
  public description!: string;
  public service_type!: string;
  public length_of_booking_slot!: number;
  public image1!: string;
  public image2!: string;
  public imagePath!: string;
  public business_type!: string;
  public customer_intake!: number;
  public service_image!: string;
  public online_booking!: boolean;
  public mobile_booking!: boolean;
  public spotsLeft: any;
  public additional_info = '';
  public cancellation_policy = '';
  public start_date!: Date;
  public end_date!: Date;
  public capacity_total!: number;
  public capacity_used!: number;
  public class_location!: string;
  public class_start_time: any;
  public class_end_time: any;
  public repeat_mode!: string;
  public repeat_type!: string;
  public weekly_days!: string[];
  public comment!: string;
  public status!: string;
  public business_id!: string;
  public service_id!: string;
  public mode_of_service!: string;
  public business!: string;
  public image_name!: string;
  public images!: any[];
  public start_times: any;
}

export class BusinessProviderDetail {
  public id!: number;
  public logo_image!: string;
  public correct_image!: string;
  public thumb_image!: string;
  public website!: string;
  public booking_mode = 'None';
  public booking_mode_api!: string;
  public logo_name!: string;
  public facebook_link!: string;
  public instagram_link!: string;
  public cancelation_policy!: number;
  public max_lead_time!: number;
  public reviews_active!: string;
  public business!: string;
  public access_key?: string;
  public secret_key?: string;
  public business_phone!: string;
  public business_profile = '';
  public business_profile_major_city = '';
  public business_profile_subhurb = '';
  public business_incorporation: any;
  public insurance_accepted: any;
  public security_policy: any;
  public cliniko_business_id: any;
  public nookal_business_id: any;
  public coreplus_business_id: any;
  public acuity_business_id: any;
  public cliniko_shard: any;
  public business_cliniko_api: any;
  public business_nookal_api: any;
  public business_coreplus_api: any;
  public business_acuity_api: any;
  public api_key: any;
  public business_id: any;
  public allow_sync!: boolean;
  public certifications: any;
  public business_radius: any;
  public mobile_service!: boolean;
  public online_service!: boolean;
}

export class BusinessProviderPhoto {
  public id!: number;
  public image!: string;
  public correct_image!: string;
  public thumb_image!: string;
  public name!: string;
  public type_of_url!: string;
  public business!: string;
}

export class BusinessProviderTiming {
  public id!: number;
  public business_day!: string;
  public day_status!: 'Closed' | 'Open';
  public business!: string;
  public start_timing!: string;
  public end_timing!: string;
  public is_multiple = false;
  public second_slot?: boolean = false;
}

export class BusinessProviderPractitioner {
  public id!: number;
  public logo_image: any;
  public correct_image!: string;
  public logo_name!: string;
  public name!: string;
  public profile!: string;
  public practitioner_service!: string[];
  //  practitioner_service_category: PractitionerServiceCategory[];
  public email!: string;
  public link_calendar: any;
  public created_at!: Date;
  public updated_at!: Date;
  public business!: string;
  public practitioner_hours!: BusinessProviderTiming[];
  public practitioner_status!: string;
  public practitioner_gender: any;
  public nookal_external_calendar_id: any;
  public mindbody_external_calendar_id: any;
  public coreplus_external_calendar_id: any;
  public external_calendar_id: any; //cliniko
  public google_calendar_id: any;
  public external_calendar_type: any;
  public calendar_id: any;
  public practitioner_certificates: any;
  public spoken_languages: any;
  public profession_title: any;
  public specialization: any;
  public qualification: any;
}

export class BusinessProviderStripe {
  public routing_number!: string;
  public bank_name!: string;
  public first_name!: string;
  public last_name!: string;
  public account_holder_name!: string;
  public business_name!: string;
  public type!: string;
  public dob = { year: 0, day: 0, month: 0 };
  public account_number: any;
  public express_url: any;
  public exist: any;
}

export class BusinessProviderData {
  public id!: number;
  public business!: number;
  public live_status!: string;
  public abn!: string;
  public acconut_id!: string;
  public card_token!: string;
  public stripe_customer_id!: string;
  public online_pay_via_stripe!: string;
  public name!: string;
  public email!: string;
  public contact_name!: string;
  public tel_no!: string;
  public slug!: string;
  public is_active!: boolean;
  public about_practitioner_check!: boolean;
  public payment_gateway_check!: boolean;
  public sponsership_payemnt!: string;
  public sponsership_upto!: string;
  public pay_venue!: string;
  public disable_cliniko_hours!: boolean;
  public premium!: boolean;
  public online_booking!: boolean;
  public mobile_booking!: boolean;
  public avaana_commission!: string;
  public uuid!: string;
  public distance!: string;
  public amenities!: string;
  public insurance: any;
  public business_cliniko_api: any;

  public business_location!: BusinessProviderLocation;
  public business_detail!: BusinessProviderDetail;
  public business_photos!: BusinessProviderPhoto[];
  public business_images!: BusinessProviderPhoto[];
  public business_days!: BusinessProviderTiming[];
  public business_holidays = [];
  public business_practitioner!: BusinessProviderPractitioner[];
  public business_stripe!: BusinessProviderStripe;
  public business_service!: BusinessProviderServices[];
  public business_class!: any[];
  public business_radius!: any[];
  public allWeeksList: any = [];
  public business_stripe_customer: any;
}

export interface IPaginationOptions {
  showResultsCount: boolean;
  showPrevNextButtons: boolean;
  showResultText: string;
  totalRecordsPerPage: number;
  totalRecords: number;
  currentPage: number;
}
